export class DisponibiliteClientDTO {

    From: string;
    To: string;

    static mapFromJSON(json) {
        const cm = new DisponibiliteClientDTO;

        cm.From = json['from'];
        cm.To = json['to'];
    }
}